import { ArticleSourceType, ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import useUserData from 'hooks/useUserData';
import { useMemo } from 'react';

export const useHelpCenter = ({ article }: { article: ArticleType }) => {
  const { companyId, isNovaOrCompanyAdmin } = useUserData();
  const { isCompanyHelpCenterArticle, isAdminHelpCenterArticle, isHelpCenterArticle } =
    useMemo(() => {
      let isCompanyHelpCenterArticle = false;
      let isAdminHelpCenterArticle = false;
      let isHelpCenterArticle = false;
      if (article?.articleType === ArticleSourceType.HELP_CENTER) {
        isHelpCenterArticle = true;
        article?.companyId === companyId
          ? (isCompanyHelpCenterArticle = true)
          : (isAdminHelpCenterArticle = true);
      }
      return { isAdminHelpCenterArticle, isCompanyHelpCenterArticle, isHelpCenterArticle };
    }, [article, companyId]);

  // We are preventing certain actions when the current article is
  // admin help center article.
  const disableAction = useMemo(
    () => isHelpCenterArticle && !(isCompanyHelpCenterArticle && isNovaOrCompanyAdmin),
    [isHelpCenterArticle, isCompanyHelpCenterArticle, isNovaOrCompanyAdmin],
  );

  return {
    isAdminHelpCenterArticle,
    isCompanyHelpCenterArticle,
    isHelpCenterArticle,
    disableAction,
  };
};
